import { Box, Button, Typography, useTheme } from "@mui/material";
import {
  IContentChannel,
  ISignagePlaylist,
  ScheduleContentRefType,
} from "@nendaTypes/NendaTypes";
import { isContentChannel } from "../../DailyPlaylist/PlaylistTimeline";
import { s } from "vite/dist/node/types.d-aGj9QkWt";
import { t } from "i18next";
import { isChannelPreviewable } from "../Preview/Preview";

const ContentCard = ({
  content,
  onClick,
  onPreview,
}: {
  content: IContentChannel | ISignagePlaylist;
  onClick: (contentId: string, contentRefType: ScheduleContentRefType) => void;
  onPreview?: (contentChannel: IContentChannel) => void;
}) => {
  const theme = useTheme();
  const onCardClick = () => {
    onClick(
      content._id,
      isContentChannel(content)
        ? ScheduleContentRefType.CONTENT_CHANNEL
        : ScheduleContentRefType.SIGNAGE_PLAYLIST
    );
  };

  const handlePreviewButtonClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.stopPropagation();
    if (isContentChannel(content)) {
      onPreview?.(content);
    }
  };

  return (
    <Box
      sx={{
        padding: "0.5rem",
        border: "0.5px solid lightgray",
        cursor: "pointer",
        display: "flex",
        gap: "0.5rem",
        alignItems: "center",
        background: "transparent",
        transition: "all 0.5s ease",

        "&:hover": {
          transition: "background 0.1s ease",
          background: "#dbd9d9",
          boxShadow: "6px 7px 31px -3px rgba(0,0,0,0.1)",
        },
        "&:hover .hoverButton": { opacity: 1 },
        "&:active": {
          transition: "all 0.5s ease",
          background: theme.palette.transparent.purple,
        },
      }}
      onClick={onCardClick}
    >
      {isContentChannel(content) ? (
        <Box
          sx={{
            position: "relative",
            height: "8rem",
            maxWidth: "6rem",
            background: "black",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
          }}
        >
          <img
            src={content.posterUrl || content.logo?.locator}
            style={{ height: "100%", width: "100%", objectFit: "contain" }}
          />

          {isChannelPreviewable(content) && (
            <Button
              variant="contained"
              color="primary"
              size="small"
              className="hoverButton"
              sx={styles.actionButton}
              onClick={handlePreviewButtonClick}
            >
              {t("common.preview")}
            </Button>
          )}
        </Box>
      ) : null}
      <Box>
        <Typography variant="body1" sx={{ color: "#2c2c2c" }}>
          {content.name}
        </Typography>
      </Box>
    </Box>
  );
};

const styles = {
  actionButton: {
    background: "white",
    "&:hover": {
      background: "#f0f0f0",
    },
    color: "black",
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "90%",
    transform: "translate(-50%, -50%)",
    opacity: 0,
    transition: "opacity 0.3s ease",
    pointerEvents: "auto",
    borderRadius: "0.2rem",
    py: "0.5rem",
  },
};

export default ContentCard;
